import React from "react";
import { Box, Typography } from "@material-ui/core";

interface Crumb {
  label: string;
  current?: boolean;
}

// The cruises funnel path leading into checkout (Figma: "Cruise Checkout
// Breadcrumbs"). Static scaffold — prior steps aren't linked yet; wire
// href/onClick to the shop-funnel routes when they're available.
const CRUMBS: Crumb[] = [
  { label: "Cabin selection" },
  { label: "Cabin location" },
  { label: "Checkout", current: true },
];

/**
 * CheckoutBreadcrumbs — the cruises funnel breadcrumb shown above the checkout
 * page: Cabin selection › Cabin location › Checkout (the current step bold).
 */
export const CheckoutBreadcrumbs = () => (
  <Box
    component="nav"
    aria-label="Breadcrumb"
    style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}
  >
    {CRUMBS.map((crumb, i) => (
      <React.Fragment key={crumb.label}>
        {i > 0 && (
          <Typography aria-hidden variant="body2" style={{ color: "#6b6b6b" }}>
            ›
          </Typography>
        )}
        <Typography
          variant="body2"
          aria-current={crumb.current ? "page" : undefined}
          style={{
            color: crumb.current ? "#1c1c1c" : "#004977",
            fontWeight: crumb.current ? 700 : 400,
          }}
        >
          {crumb.label}
        </Typography>
      </React.Fragment>
    ))}
  </Box>
);
